"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.posOrderItemToOrderDetailProductMapper = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var posOrderItemToOrderDetailProductMapper = function (posOrderItem, amount, depth) {
    if (depth === void 0) { depth = 0; }
    var sourceId = posOrderItem.sourceId, ticketName = posOrderItem.ticketName, tax = posOrderItem.tax, quantity = posOrderItem.quantity, applyScopeId = posOrderItem.applyScopeId, _a = posOrderItem.labels, labels = _a === void 0 ? [] : _a, businessId = posOrderItem.businessId, purchasePrice = posOrderItem.purchasePrice, billingCode = posOrderItem.billingCode;
    if (posOrderItem.childItems) {
        delete posOrderItem.childItems;
    }
    return {
        id: sourceId,
        depth: depth,
        quantity: +quantity,
        label: ticketName,
        taxRate: new bignumber_js_1.default(tax).shiftedBy(4).toNumber(),
        amount: amount,
        applyScopeId: applyScopeId,
        tags: labels.map(function (_a) {
            var label = _a.label;
            return label;
        }),
        additionalData: posOrderItem,
        sku: businessId,
        purchasePrice: purchasePrice && new bignumber_js_1.default(purchasePrice).multipliedBy(100).toNumber(),
        billingCode: billingCode,
    };
};
exports.posOrderItemToOrderDetailProductMapper = posOrderItemToOrderDetailProductMapper;
